import { render, staticRenderFns } from "./dataView.vue?vue&type=template&id=39273826&scoped=true"
import script from "./dataView.vue?vue&type=script&lang=js"
export * from "./dataView.vue?vue&type=script&lang=js"
import style0 from "./dataView.vue?vue&type=style&index=0&id=39273826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39273826",
  null
  
)

export default component.exports